export default "__VITE_ASSET__af8bc754__"